import { ChangeDetectionStrategy, Component, ViewChild, inject } from '@angular/core';
import { UbSubscribeService } from '@components/storage-accounts/ub-subscribe.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ButtonComponent, ModalComponent, ModalFooterDirective } from 'mbs-ui-kit';
import { StorageType } from 'mbs-ui-shared';
import { Balance } from 'mbs-ui-shared@components/components/models/license.model';
import { BALANCE_TOKEN } from 'mbs-ui-shared@components/licenses/tokens/balance.token';
import { AuthFacade } from 'mbs-ui-shared@facades/auth.facade';
import { CurrentCredits } from 'mbs-ui-shared@models/storage-accounts/CurrentCredits';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { AsyncPipe, CommonModule } from '@angular/common';

@UntilDestroy()
@Component({
  selector: 'mbs-ub-aws-changing-price-modal',
  templateUrl: './ub-aws-changing-price-modal.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, ButtonComponent, CommonModule, ModalComponent, ModalFooterDirective]
})
export class UbAwsChangingPriceModalComponent {
  private ubSubscribe = inject(UbSubscribeService);
  authService = inject(AuthFacade);
  balance = inject<Observable<Balance>>(BALANCE_TOKEN);

  public loading$ = new BehaviorSubject<boolean>(false);
  public credits: CurrentCredits;
  public storageType: StorageType;

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  handleResolve(): void {
    this.loading$.next(true);
    this.ubSubscribe
      .spendCredits(this.storageType)
      .pipe(
        untilDestroyed(this),
        finalize(() => this.loading$.next(false))
      )
      .subscribe((credits) => {
        if (!credits || credits.paymentLink == null) {
          this.baseModal.save(true);
        } else {
          window.location.href = credits.paymentLink;
        }
      });
  }
}
